import React, { useEffect, useReducer, useState } from 'react';
import colors from '../../assets/styles/colors';
import Copyright from '../../components/Copyright';
import FormSteps from '../../components/FormSteps';
import Loader from '../../components/Loader';
import { H4, P } from '../../components/Typography/styles';
import {
 IdentityValidationContainer,
 IdentityValidationWrapper,
 IdentityValidationHeader,
 IdentityValidationHeaderTitle,
 IdentityValidationHeaderArea,
 IdentityValidationContent
} from './styles';
import identityValidationReducer from '../../store/IdentityValidation';
import IdentityValidationTypes from '../../store/IdentityValidation/types';
import INITIAL_STATE_IDENTITY_VALIDATION from '../../store/IdentityValidation/state';
import { IdentityValidationContext } from '../../store';
import { useHistory, useLocation } from 'react-router-dom';
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import { identityValidationSteps } from '../../helpers/enum';
import ValidationCheckPage from './ValidationCheck';

const ClientIdentityValidationPage = () => {
    const location = useLocation();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [identityValidation, setIdentityValidation] = useReducer(identityValidationReducer, INITIAL_STATE_IDENTITY_VALIDATION);
    const [activeStep, setActiveStep] = useState(identityValidationSteps.DIGITAL_DOCUMENTS);
    const [lastStep, setLastStep] = useState(identityValidationSteps.DEFAULT);

    async function initializeStateComponent() {
        try {
            const creditResponse = await getCreditById(location.idCredit);
            const solicitationResponse = await getSolicitationById(location.idCredit);
        
            setIdentityValidation({
                type: IdentityValidationTypes.SET_CREDIT,
                credit: creditResponse.data
            })
        
            setIdentityValidation({
                type: IdentityValidationTypes.SET_SOLICITATION,
                solicitation: solicitationResponse.data
            })
        
            if(location.step) {
                setActiveStep(location.step);
                setLastStep(identityValidationSteps.DIGITAL_DOCUMENTS);
            }
            setIsLoading(false);
        } catch (error) {
        
        }
    }

    useEffect(function () {
        if(!location.idCredit) {
            return history.push('/admin/dashboard');
        }
        initializeStateComponent();
    }, []);

    return (
        <IdentityValidationContainer id="identity-validation-page">
            {isLoading ? <Loader /> : (
                <>
                <IdentityValidationWrapper>
                <IdentityValidationHeader>
                    <IdentityValidationHeaderTitle>Clientes</IdentityValidationHeaderTitle>
                    <IdentityValidationHeaderArea>
                    <H4 color={colors.textPrimary}>Validación de Identidad de Cliente</H4>
                    <P bold color={colors.textPrimary}>
                        {identityValidation.solicitation?.cliente.nombres} {identityValidation.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {identityValidation.solicitation?.cliente.identificacion}
                    </P>
                    </IdentityValidationHeaderArea>
                </IdentityValidationHeader>

                <IdentityValidationContent id="identity-validation-steps">
                    <FormSteps lastStep={lastStep} steps={[
                    {number: identityValidationSteps.WAIT_FOR_VALIDATION, label: 'Validación de identidad'}
                    ]} />

                    <IdentityValidationContext.Provider value={{ identityValidation, setIdentityValidation }}>
                    {activeStep === identityValidationSteps.DIGITAL_DOCUMENTS && (
                        <ValidationCheckPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
                    )}
                    </IdentityValidationContext.Provider>
                </IdentityValidationContent>
                </IdentityValidationWrapper>
                <Copyright />
            </>
            )}
            </IdentityValidationContainer>
    )
}

export default ClientIdentityValidationPage;
